export default function SocialFixed() {
    const socialFixed = document.querySelector('.social-fixed');

    if (!socialFixed) return;

    const handleScroll = () => {
        const scrollPosition = window.scrollY;
        const fiftyVh = window.innerHeight * 0.5; // Calculate 50vh

        if (scrollPosition > fiftyVh) {
            socialFixed.classList.add('hidden');
        } else {
            socialFixed.classList.remove('hidden');
        }
    };

    window.addEventListener('scroll', handleScroll);
}
